import { computed, ref } from "#imports";
function useRequest(request, parametersGetter, options) {
  const isLoading = ref(false);
  const parameters = computed(
    parametersGetter || (() => ({}))
  );
  const additionalIsValid = computed(options?.validation || (() => true));
  const body = computed(
    () => "body" in parameters.value ? parameters.value.body : void 0
  );
  const params = computed(
    () => "params" in parameters.value ? parameters.value.params : void 0
  );
  const query = computed(
    () => "query" in parameters.value ? parameters.value.query : void 0
  );
  const isValid = computed(
    () => (request.schemas?.body?.isValidSync(body.value) ?? true) && (request.schemas?.params?.isValidSync(params.value) ?? true) && (request.schemas?.query?.isValidSync(query.value) ?? true) && additionalIsValid.value
  );
  const execute = (options2) => {
    if (!isValid.value || isLoading.value) return;
    isLoading.value = true;
    return request(parameters.value, options2).finally(() => isLoading.value = false);
  };
  return {
    execute,
    isValid,
    isLoading,
    parameters
  };
}
export default useRequest;
